<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">{{ title }}</div>
      <div slot="sub-title">{{ subtitle }}</div>
      <div slot="right">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-narrow">

          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <group-card :service-id="serviceId" :start-date="startDate" :end-date="endDate"/>
    </section>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import GroupCard from './GroupCard'
import ServiceService from '@/services/ServiceService'

export default {
  name: 'home',
  components: {
    HeroBar,
    GroupCard
  },
  created () {
    if (this.serviceId) {
      this.getService()
    }
  },
  data () {
    return {
      serviceId: this.$route.params.id,
      service: null,
      isLoading: true
    }
  },
  methods: {
    async getService () {
      this.isLoading = true
      let params = {
        'include[0]': 'status'
      }
      let response = await ServiceService.getService(this.serviceId, params)
      this.service = response.data.data
      this.isLoading = false
    }
  },
  watch: {
    '$route.params.id' () {
      this.serviceId = this.$route.params.id
    },
    serviceId () {
      this.getService()
    }
  },
  computed: {
    title () {
      return this.service ? `Servicio ${this.service.name}` : 'Servicio'
    },
    subtitle () {
      let subtitle
      if (this.service) {
        let startDate = this.service.start_date
        let endDate = this.service.end_date
        let formatedSD = startDate ? `Desde el ${this.$moment(startDate, 'YYYY-MM-DD').format('DD MMMM')}` : ''
        let formatedED = endDate ? `al ${this.$moment(endDate, 'YYYY-MM-DD').format('DD MMMM')}` : ''
        subtitle = `${formatedSD} ${formatedED}`
      } else {
        subtitle = ''
      }
      return subtitle
    },
    startDate () {
      let startDate = this.service ? this.service.start_date : null
      if (startDate) {
        return this.$moment(startDate, 'YYYY-MM-DD').toDate()
      } else {
        return null
      }
    },
    endDate () {
      let endDate = this.service ? this.service.end_date : null
      if (endDate) {
        return this.$moment(endDate, 'YYYY-MM-DD').toDate()
      } else {
        return null
      }
    }
  }
}
</script>
